export default "__VITE_ASSET__D2XKsyjU__"